module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-14-ffb70d28dfd2898abb0b2d799ba8b6cf.jpg";